export const MY_ACCOUNT_CHRISTMAS_FILLED = "accountChristmasFilled";
export const MY_ACCOUNT_CHRISTMAS_UNFILLED = "accountChristmasUnfilled";
export const MY_ACCOUNT_EASTER_FILLED = "accountEasterFilled";
export const MY_ACCOUNT_EASTER_UNFILLED = "accountEasterUnfilled";
export const MY_ACCOUNT_FILLED = "accountFilled";
export const MY_ACCOUNT_STPATRICKS_FILLED = "accountStPatricksFilled";
export const MY_ACCOUNT_STPATRICKS_UNFILLED = "accountStPatricksUnfilled";
export const MY_ACCOUNT_UNFILLED = "accountUnfilled";
export const SAVED_ITEMS_FILLED = "heartFilled";
export const SAVED_ITEMS_UNFILLED = "heartUnfilled";
export const SAVED_ITEMS_VALENTINES_FILLED = "savedValentinesFilled";
export const SAVED_ITEMS_VALENTINES_UNFILLED = "savedValentinesUnfilled";
